import styled, { css } from 'styled-components'

const iconType = ({ type }) => {
  if (type === 'confirmed') {
    return css`
      background-color: rgba(5, 148, 79, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(5, 148, 79, 1);
      }
    `
  } else if (type === 'rejected') {
    return css`
      background-color: rgba(225, 25, 0, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `
  }
}

export const AddNewCongregationBtnWrapper = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: rgba(10, 161, 244, 1);
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  font-family: Inter;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);;

  svg {
    path {
      fill: rgba(10, 161, 244, 1);
      fill-opacity: 1;

    }
  }
`

export const CongregationContentFinishEditingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 32px 0 64px 0;

`

export const CongregationHeaderWrapper = styled.div`
  width: 100%;
  height: 54px;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border-bottom: ${(p) => {
    return p.borderBottom ? '1px solid rgba(32, 32, 32, 0.1)' : 'none'
  }};
  margin-bottom: ${(p) => {
    return p.marginBottom ? '64px' : '0'
  }};
`

export const CongregationHeaderHalfSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const CongregationHeaderDotIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : '#0aa1f4'
  }};
`

export const CongregationHeaderTitle = styled.div`
 font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  height: 16px;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 16px;
  max-width: ${(p) => {
    return p.isReassess ? '493px' : '630px'
  }};
  text-overflow: ellipsis;
  color: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const CongregationHeaderRemoveIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  cursor: pointer;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const CongregationValidationIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`

export const CongregationValidationIconWrapper = styled.div`
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
`

export const CongregationsHeaderLastReassessmentCalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CongregationHeaderCalendarIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  margin-right: 8px;
`

export const CongregationHeaderCalendarDateText = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-bottom: 1px dotted rgba(32, 32, 32, 0.5);
`

export const CongregationHeaderCalendarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 24px;
`

export const CongregationListTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 32px;
  color: rgba(32, 32, 32, 0.7);
  border-bottom: 1px dotted rgba(32, 32, 32, 0.7);
  margin-top: ${(p) => {
    return p.marginTop
  }};
`
export const CongregationListTitleWrapper = styled.div`
  margin-top: ${(p) => {
    return p.addMarginTop ? '64px' : '0'
  }};
  width: 100%;
  display: flex;
  justify-content: center;
`

export const CongregationConfirmDeclineIcon = styled.div`
  margin-right: 24px;
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  ${iconType}
`

export const CongregationToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

